import { Form, Input, Checkbox } from "antd";
import LoginDashBoard from "./LoginDashBoard";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

import { openNotification } from "../../utils/UI/openNotification";
import { loginUser } from "../../apis/loginApis/loginEndpoint";

const Login = () => {
  const navigate = useNavigate();

  const onFinish = (values: any) => {
    userLoginHandle(values);
  };

  const onFinishFailed = (errorInfo: object) => {
  };

  const [error, setError] = useState("");
  const userLoginHandle = async (payload: any) => {
    try {
      if (!payload) throw new Error("Enter valid user data.");
      const res = await loginUser(payload);
      if (!res.status) throw res;
      localStorage.setItem(
        "token",
        JSON.stringify(res.data?.tokens.access) || ""
      ); // access token
      localStorage.setItem(
        "user",
        JSON.stringify(res.data?.user) || ""
      ); // user
      localStorage.setItem(
        "user_data",
        JSON.stringify(res.data?.user_data) || ""
      ); // user
      const is2FARequired=res.data?.user?.is2FARequired
      const is2FAEnabled=res.data?.user?.is2FAEnabled
      if (is2FARequired) {
        if (is2FAEnabled) {
          navigate("/2fa", { state: { email: res.data?.user?.email } });
        } else {
          navigate("/setup2fa", { state: { email: res.data?.user?.email } });
        }
      } else {
        localStorage.setItem('2FAVerified', 'true');
        navigate('/dashboard/overview');
      }
      setError("");
    } catch (err: any) {
      setError("Login Or Password Is Incorrect");
      openNotification("error", {
        message: err?.message || "Something went wrong",
      }); 
    }
  };

  return (
    <>
      <LoginDashBoard>
        <div
          className={`${error ? "flex" : "hidden"} w-full justify-center items-center p-2 shadow rounded bg-lightred rounded-sm`}
        >
          <span className="text-red-600 text-xs ">{error}</span>
        </div>

        <Form
          name="login"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          // onSubmit={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <div className="!text-[10px]">
            <span className="text-lightGrey text-sm  font-poppins font-normal break-words">
              Email:
            </span>
          </div>

          <Form.Item
            name="email"
            className="bg-white"
            rules={[{ required: true, message: "Please input your email!" }]}
          >
            <Input
              type="email"
              className="md:min-h-[55px] max-h-[29px] text-xl text-lightGrey  rounded-lg border border-inputBorder"
            />
          </Form.Item>

          <div className="flex justify-between items-center w-full">
            <span className="text-lightGrey text-sm font-poppins font-normal break-words">
              Password:
            </span>
            <a
              className="text-inputBorder text-xs font-poppins font-light break-words hover:text-inputBorder"
              href="/forgot-password"
            >
              Forgot Password?
            </a>
          </div>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password className="md:min-h-[55px] max-h-[29px] text-xl text-lightGrey rounded-lg border border-inputBorder" />
          </Form.Item>

          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox className="loginCheckbox text-inputBorder text-xs font-poppins font-light break-words hover:text-inputBorder">
              Remember Password
            </Checkbox>
          </Form.Item>

          <Form.Item className="mt-5 flex justify-center">
            <button
              type="submit"
              className="md:min-w-[415px] md:min-h-[55px] min-w-[220.92px] min-h-[29.62px] rounded-md bg-yellow hover:bg-darkyellow   "
            >
              <span className="text-white text-base font-poppins font-bold break-words">
                Login
              </span>
            </button>
          </Form.Item>
        </Form>
      </LoginDashBoard>
      <style>{`
      .loginCheckbox .ant-checkbox-checked .ant-checkbox-inner{
        border: 1px #9F9F9F solid;
        background-color:transparent;
      }
      // .loginCheckbox .ant-checkbox-checked .ant-checkbox-inner:hover{
      //   border: 1px #9F9F9F solid !important;
      //   background-color:transparent !important;
      // }
      .loginCheckbox .ant-checkbox .ant-checkbox-inner:after{
        border: 2px #9F9F9F solid;
        border-top: none;
    border-left: none;
      }
      `}</style>
    </>
  );
};

export default Login;
